import useMeetingsRefresh from "../../hooks/useMeetingsRefresh";
import RefreshMeetingsButton from "./RefreshMeetingsButton";
//final latest
import React, { useEffect, useRef, useState } from "react";
import { useContext } from "react";
import TherapyRoomCard from "./TherapyRoomCard";
import Navbar from "../Navbar";
import FallScene from "../FallScene";
import Footer from "../Footer";
import { AuthContext } from "../../context/AuthContext";
import beach from "../../assets/images/beach.png";
import forest from "../../assets/images/forest.png";
import campsite from "../../assets/images/campsite.png";
import park from "../../assets/images/park.png";
import { useNavigate } from "react-router-dom";
import NewSpace from "../../assets/images/NewSpace.png"
import winterHoliday from "../../assets/images/winterHoliday.png"
import zen from "../../assets/images/zen.png"
import Env from '../../runtimeEnv';
import axios from "../../api/axiosInstance";
import WarningBanner from '../WarningBanner';
import { isNativeMobileShell, launchNativeUnitySession } from '../../native/mobileBridge';
import { createDemoMeetings, isDemoMode } from '../../demo/demoMode';
import {
  createInitialUnityPreloadStates,
  isDesktopUnityPreloadEligible,
  isUnityRoomCached,
  markUnityRoomPreloaded,
  preloadUnityRoom,
  prioritizeUnityRooms,
} from "../../utils/unityWebglPreloader";
import { preloadUnityRoomLoadingImages } from "../../utils/unityRoomLoadingImages";

const CLIENT_PRELOAD_ROOMS = [
  { id: "beach" },
  { id: "mountain" },
  { id: "park" },
  { id: "campsite" },
  { id: "winter-holiday" },
];

function ClientTherapyRooms() {
  const navigate = useNavigate();
  const [enabledRoom, setEnabledRoom] = useState([]);
  // const [loading, setLoading] = useState(true);
  const [roomsOnlineStatus, setRoomsOnlineStatus] = useState({});
  const [sessionStartTimes, setSessionStartTimes] = useState({});
  const [selectedSpace, setSelectedSpace] = useState(null);
  const selectedSpaceRef = useRef(selectedSpace);
  selectedSpaceRef.current = selectedSpace;
  const [selectedSpaceResolved, setSelectedSpaceResolved] = useState(false);
  const [meetingExists, setMeetingExists] = useState(false);
  const [preloadStates, setPreloadStates] = useState(() =>
    createInitialUnityPreloadStates(CLIENT_PRELOAD_ROOMS)
  );
  const {
    currentNickname,
    setCurrentNickname,
    PlutonicuserID,
    loading,
    setLoading,
    userType,
    
  } = useContext(AuthContext);

  useEffect(() => {
    if (isDesktopUnityPreloadEligible()) {
      void preloadUnityRoomLoadingImages();
    }
  }, []);

  const { refreshMeetings, refreshing, refreshError } = useMeetingsRefresh(async (signal) => {
      const savedUserID =
        PlutonicuserID || localStorage.getItem("PlutonicuserID");
      const savedNickname =
        currentNickname || localStorage.getItem("currentNickname");

      if (savedNickname) {
        setCurrentNickname(savedNickname);
      }

      if (savedUserID) {
        try {
          const meetingRows = isDemoMode
            ? createDemoMeetings()
            : (await axios.get(
                `${Env.REACT_APP_PYTHON_API_URL}/api/GetMeetings/${savedUserID}`,
                { withCredentials: true,  signal, params: { t: Date.now() } }
              )).data;

          if (signal.aborted) return;
          if (meetingRows.length > 0) {
            const nowUTC = new Date();
            const gracePeriodBeforeMs = 15 * 60 * 1000;
            const gracePeriodAfterMs = 75 * 60 * 1000;
            const backToBackBufferMs = 20 * 60 * 1000;

            let hasEligibleMeeting = false;
            let latestUpcomingSession = null;

            const roomSessionsMap = meetingRows.reduce((acc, room) => {
              const roomId = room.meetingID.split(".")[0].replace("-therapy", "");
              const sessionTimeUTC = new Date(room.sessionTime);

              const formattedTimeEST =
                sessionTimeUTC.toLocaleString("en-US", {
                  timeZone: "America/New_York",
                  month: "2-digit",
                  day: "2-digit",
                  year: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                  hour12: true,
                }) + " EST";

              if (!acc[roomId]) acc[roomId] = [];

              acc[roomId].push({
                meetingID: room.meetingID,
                sessionStartTimeEST: formattedTimeEST,
                sessionStartTimeUTC: sessionTimeUTC.toISOString(),
                rawStartTime: sessionTimeUTC,
                online: room.online.some((s) => s === true),
                isAvailable: false,
                isUpcoming: false,
              });

              return acc;
            }, {});

            Object.keys(roomSessionsMap).forEach((roomId) => {
              const sessions = roomSessionsMap[roomId];
              sessions.sort(
                (a, b) =>
                  new Date(a.sessionStartTimeUTC) -
                  new Date(b.sessionStartTimeUTC)
              );

              for (let i = 0; i < sessions.length; i++) {
                const current = sessions[i];
                const next = sessions[i + 1];

                const currentStart = new Date(current.sessionStartTimeUTC);
                const timeUntilCurrent = currentStart - nowUTC;
                const timeSinceCurrent = nowUTC - currentStart;

                const isInGraceWindow =
                  (timeUntilCurrent <= gracePeriodBeforeMs &&
                    timeUntilCurrent >= 0) ||
                  (timeSinceCurrent >= 0 &&
                    timeSinceCurrent <= gracePeriodAfterMs);

                const isUpcoming =
                  timeUntilCurrent > 0 &&
                  timeUntilCurrent <= gracePeriodBeforeMs;
                let isSuppressed = false;

                if (next) {
                  const nextStart = new Date(next.sessionStartTimeUTC);
                  const timeUntilNext = nextStart - nowUTC;
                  const allowSuppression =
                    timeUntilNext <= backToBackBufferMs &&
                    timeUntilNext >= -15 * 60 * 1000;

                  if (allowSuppression) {
                    isSuppressed = true;
                    next.isUpcoming = true;
                  }
                }

                current.isAvailable = isInGraceWindow;
                current.isUpcoming = isUpcoming;
                current.isPrimary =
                  (isInGraceWindow || isUpcoming) && !isSuppressed;

                // if (current.isAvailable || current.isUpcoming) {
                //   hasEligibleMeeting = true;
                // }
                hasEligibleMeeting = true; // Mark as true if *any* session exists, not just active/upcoming

                if (
                  current.isPrimary &&
                  (!latestUpcomingSession ||
                    currentStart >
                      new Date(latestUpcomingSession.sessionStartTimeUTC))
                ) {
                  latestUpcomingSession = current;
                }
              }
            });

            const sessionStartTimesMap = Object.entries(roomSessionsMap).reduce(
              (acc, [roomId, sessions]) => {
                const nextSession = sessions.find(
                  (session) => session.isAvailable || session.isUpcoming
                );
                if (nextSession) acc[roomId] = nextSession.sessionStartTimeEST;
                return acc;
              },
              {}
            );

            const onlineStatusMap = Object.entries(roomSessionsMap).reduce(
              (acc, [roomId, sessions]) => {
                acc[roomId] = sessions.some((session) => session.online);
                return acc;
              },
              {}
            );

            setRoomsOnlineStatus(onlineStatusMap);
            setEnabledRoom(roomSessionsMap);
            setSessionStartTimes(sessionStartTimesMap);
            setMeetingExists(hasEligibleMeeting);
          } else {
            setEnabledRoom({});
            setRoomsOnlineStatus({});
            setSessionStartTimes({});
            setMeetingExists(false);
          }
        } catch (error) {
          if (!signal.aborted) setLoading(false);
          throw error;
        }
      }

      if (!signal.aborted) setLoading(false);
  }, PlutonicuserID);

  useEffect(() => {
    let active = true;
    setSelectedSpaceResolved(false);

    if (!PlutonicuserID) {
      setSelectedSpaceResolved(true);
      return () => {
        active = false;
      };
    }

    if (isDemoMode) {
      setSelectedSpace("beach");
      setSelectedSpaceResolved(true);
      return () => {
        active = false;
      };
    }

    axios
      .get(
        `${Env.REACT_APP_PYTHON_API_URL}/api/get-selected-space/${PlutonicuserID}`,
        { withCredentials: true }
      )
      .then((res) => {
        if (!active) return;
        setSelectedSpace(res.data.selectedSpace || null);
      })
      .catch(() => console.error("Error fetching selected space:"))
      .finally(() => {
        if (active) setSelectedSpaceResolved(true);
      });

    return () => {
      active = false;
    };
  }, [PlutonicuserID]);

  // ✅ Step 3: Handle space selection (only if meeting exists)
  const handleSpaceSelection = (spaceId) => {
    if (isDemoMode) {
      setSelectedSpace(spaceId);
      return;
    }
    // console.log("Selected Space ID:", spaceId);
    // if (!meetingExists) {
    //     alert("No active meeting found. Cannot select a space.");
    //     return;
    // }
    if (!meetingExists) {
      // Find latest past session across all rooms
      const allSessions = Object.values(enabledRoom).flat();
      const now = new Date();
      const pastSessions = allSessions
        .filter((session) => new Date(session.rawStartTime) < now)
        .sort((a, b) => new Date(b.rawStartTime) - new Date(a.rawStartTime));

      const latestPastSession = pastSessions[0];


      if (!latestPastSession) {
        // alert("No session history found to save your selection.");
        return;
      }

      axios
        .post(`${Env.REACT_APP_PYTHON_API_URL}/api/select-space`, {
          PlutonicuserID: PlutonicuserID,
          selectedSpace: spaceId,
          meetingID: latestPastSession.meetingID, // Include the past meeting ID
        }, { withCredentials: true })
        .then(() => {
          setSelectedSpace(spaceId);
          // console.log("Space selection saved to latest past session.");
        })
        .catch((err) => console.error("Error updating space selection:"));

      return;
    }

    if (selectedSpace === spaceId) {
      // console.log("Space is already selected. No API call needed.");
      return; // ✅ Avoid unnecessary API request
    }

    setSelectedSpace(spaceId);
    axios
      .post(`${Env.REACT_APP_PYTHON_API_URL}/api/select-space`, {
        PlutonicuserID: PlutonicuserID,
        selectedSpace: spaceId,
      }, { withCredentials: true })
      .then(() => undefined)
      .catch((err) => console.error("Error updating space selection:"));
  };

  const allRooms = [
    {
      id: "zen-garden",
      title: "Plutonic Therapy Zen Garden",
      description:
        "Step into a calming Zen inspired retreat designed to hlep you relax, reflect, and feel more comfortable opening up with your therapist.",
      accessibility: "PC Web Browser | Chrome, Edge",
      style: "Seasonal",
      usage: "Seasonal",
      image: zen,
      available:
        enabledRoom["zen-garden"]?.some((session) => session.isAvailable) ||
        false,
      selectable: false, // Selectable if a meeting exists
      // enterable: enabledRoom["park"]?.some((session) => session.isAvailable) ?? false, // Enterable only if within grace period
      isComingSoon: true,
      online: false,
      sessionStartTimeEST: "",
    },
    {
      id: "beach",
      title: "Plutonic Therapy Beach Office",
      description:
        "Consider having a session with your licensed mental health professional inside the office or in the cabana. Take in the sounds of the ocean waves and the sunset as you reduce stress.",
      accessibility: "PC Web Browser | Chrome, Edge",
      style: "Modern Design",
      usage: "Family Counseling",
      image: beach,
      // available: enabledRoom["beach"]?.some((session) => session.isAvailable) || false,
      selectable: enabledRoom["beach"]?.length > 0 ?? false, // Selectable if a meeting exists
      available:
        enabledRoom["beach"]?.some((session) => session.isAvailable) ?? false, // Enterable only if within grace period
      isComingSoon: false,
      online: roomsOnlineStatus["beach"] || false,
      sessionStartTimeEST: sessionStartTimes["beach"] || "",
    },
    {
      id: "mountain",
      title: "Plutonic Therapy Forest Office",
      description:
        "Consider having a session with your licensed mental health professional next to the fireplace. Take in the sounds and sights of the forest.",
      accessibility: "PC Web Browser | Chrome, Edge",
      style: "Modern Design",
      usage: "Family Counseling",
      image: forest,
      // available: enabledRoom["mountain"]?.some((session) => session.isAvailable) || false,
      // selectable: false, // Cannot select "coming soon" rooms
      available:
        enabledRoom["mountain"]?.some((session) => session.isAvailable) ||
        false,
      selectable: enabledRoom["mountain"]?.length > 0 ?? false, // Selectable if a meeting exists
      isComingSoon: false,
      online: roomsOnlineStatus["mountain"] || false,
      sessionStartTimeEST: sessionStartTimes["mountain"] || "",
    },

    {
      id: "park",
      title: "Plutonic Therapy Quiet Park",
      description:
        "Consider having a session with your licensed mental health professional while taking a walk around the park or while sitting on a park bench. This quiet park is a perfect safe space to talk.",
      accessibility: "PC Web Browser | Chrome, Edge",
      style: "Green Space",
      usage: "Family Counseling",
      image: park,
      available:
        enabledRoom["park"]?.some((session) => session.isAvailable) || false,
      selectable: enabledRoom["park"]?.length > 0 ?? false, // Selectable if a meeting exists
      // enterable: enabledRoom["park"]?.some((session) => session.isAvailable) ?? false, // Enterable only if within grace period
      isComingSoon: false,
      online: roomsOnlineStatus["park"] || false,
      sessionStartTimeEST: sessionStartTimes["park"] || "",
    },
    {
      id: "campsite",
      title: "Plutonic Therapy Campfire",
      description:
        "Unpack your thoughts with your licensed mental health professional next to the campfire. Trees swaying and crickets chirping while enjoying the beautiful night sky. ",
      accessibility: "PC Web Browser | Chrome, Edge",
      style: "Green Space",
      usage: "Family Counseling",
      image: campsite,
      available:
        enabledRoom["campsite"]?.some((session) => session.isAvailable) ||
        false,
      selectable: enabledRoom["campsite"]?.length > 0 ?? false, // Selectable if a meeting exists
      // enterable: enabledRoom["park"]?.some((session) => session.isAvailable) ?? false, // Enterable only if within grace period
      isComingSoon: false,
      online: roomsOnlineStatus["campsite"] || false,
      sessionStartTimeEST: sessionStartTimes["campsite"] || "",
    },
    {
                  id: "winter-holiday",
                  title: "Plutonic Therapy Winter Cabin",
                  description:
                    "Step into a cozy winter lodge where soft snow falls outside and warm lantern lights fills the cabin. Settle into the gentle winter ambience.",
                  accessibility: "PC Web Browser | Chrome, Edge",
                  style: "Seasonal",
                  usage: "Seasonal",
                  image: winterHoliday,
                  available:
                    enabledRoom["winter-holiday"]?.some((session) => session.isAvailable) ||
                    false,
                  selectable: enabledRoom["winter-holiday"]?.length > 0 ?? false, // Selectable if a meeting exists
                  // enterable: enabledRoom["park"]?.some((session) => session.isAvailable) ?? false, // Enterable only if within grace period
                  isComingSoon: false,
                  online: roomsOnlineStatus["winter-holiday"] || false,
                  sessionStartTimeEST: sessionStartTimes["winter-holiday"] || "",
                },
  ];

  const roomOrder = ["beach", "campsite", "mountain", "park", "winter-holiday"];
  const orderedRooms = allRooms
    .filter((room) => room.id !== "zen-garden")
    .sort((a, b) => roomOrder.indexOf(a.id) - roomOrder.indexOf(b.id));

  const rooms = isNativeMobileShell()
    ? orderedRooms.map((room) =>
        room.id === "beach"
          ? room
          : {
              ...room,
              available: false,
              selectable: false,
              isComingSoon: true,
              mobileComingSoon: true,
              online: false,
              unavailableLabel: "Coming Soon on Mobile",
            }
      )
    : orderedRooms;

  useEffect(() => {
    if (loading || !selectedSpaceResolved || !isDesktopUnityPreloadEligible()) {
      return undefined;
    }

    const controller = new AbortController();
    const roomsToPreload = prioritizeUnityRooms(
      CLIENT_PRELOAD_ROOMS,
      selectedSpaceRef.current
    );

    const preloadInPriorityOrder = async () => {
      await preloadUnityRoomLoadingImages();
      if (controller.signal.aborted) return;
      const cacheResults = await Promise.all(roomsToPreload.map(async (room) => {
        const cached = await isUnityRoomCached(room.id, controller.signal);
        if (!controller.signal.aborted) {
          setPreloadStates((states) => ({
            ...states,
            [room.id]: cached
              ? { status: "complete", progress: 1, blocksEntry: false }
              : { status: "queued", progress: 0, blocksEntry: false },
          }));
        }
        return [room.id, cached];
      }));
      if (controller.signal.aborted) return;
      const cachedRoomIds = new Set(
        cacheResults.filter(([, cached]) => cached).map(([roomId]) => roomId)
      );
      for (const room of roomsToPreload) {
        if (controller.signal.aborted) return;
        if (cachedRoomIds.has(room.id)) continue;
        setPreloadStates((states) => ({
          ...states,
          [room.id]: { status: "loading", progress: 0, blocksEntry: false },
        }));
        try {
          await preloadUnityRoom(
            room.id,
            (progress) => setPreloadStates((states) => ({
              ...states,
              [room.id]: { status: "loading", progress, blocksEntry: false },
            })),
            controller.signal
          );
          markUnityRoomPreloaded(room.id);
          setPreloadStates((states) => ({
            ...states,
            [room.id]: { status: "complete", progress: 1 },
          }));
        } catch (error) {
          if (controller.signal.aborted || error.name === "AbortError") return;
          console.warn(`Unable to preload ${room.id}. The space can still be opened normally.`, error);
          setPreloadStates((states) => ({
            ...states,
            [room.id]: { status: "error", progress: 0 },
          }));
        }
      }
    };

    void preloadInPriorityOrder().catch((error) => {
      if (!controller.signal.aborted && error.name !== "AbortError") {
        console.warn("Unable to initialize Unity space preloading.", error);
      }
    });
    return () => controller.abort();
  }, [loading, selectedSpaceResolved]);

  const handleEnterClick = (roomType, meetingID = null) => {
    const userId = PlutonicuserID || localStorage.getItem("PlutonicuserID");

    if (meetingID && launchNativeUnitySession({
      roomId: roomType,
      sessionId: meetingID,
      userId,
      displayName: currentNickname || localStorage.getItem("currentNickname"),
      userType,
    })) {
      return;
    }

    // Handle test rooms
    if (
      roomType === "test-beach" ||
      roomType === "test-park" ||
      roomType === "test-forest" ||
      roomType === "test-campsite"
    ) {
      const testMeetingID = `${roomType}-test-meeting-id`;
      sessionStorage.setItem("meetingID", testMeetingID);
      sessionStorage.setItem("userId", userId);

      const realRoomType =
        roomType === "test-beach"
          ? "beach"
          : roomType === "test-park"
          ? "park"
          : roomType === "test-forest"
          ? "forest"
          : roomType === "test-campsite"
          ? "campsite"
          : "";

      // console.log(`[TestPage] Navigating to Unity build for ${realRoomType} room`);
      navigate(`/unity-room/${realRoomType}`);
      return;
    }

    if (meetingID) {
      // Directly enter the selected session
      sessionStorage.setItem("meetingID", meetingID);
      sessionStorage.setItem("userId", userId);
      navigate(`/unity-room/${roomType}`);
      return;
    }

    // Otherwise fallback to finding an available session
    const roomSessions = enabledRoom[roomType];
    if (!roomSessions || roomSessions.length === 0) {
      // alert("Room is not enabled. Please wait or check your eligibility.");
      return;
    }

    const session = roomSessions.find((s) => s.isAvailable);
    if (!session) {
      // alert("No active session is available at this time.");
      return;
    }

    sessionStorage.setItem("meetingID", session.meetingID);
    sessionStorage.setItem("userId", userId);
    navigate(`/unity-room/${roomType}`);
  };

  if (loading) {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <div>
      <Navbar
      // setCurrentNickname={(nickname) => {
      //   setCurrentNickname(nickname);
      //   localStorage.setItem("currentNickname", nickname);
      // }}
      // currentNickname={currentNickname}
      // handleLogout={handleLogout}
      // setCurrentFormType={setCurrentFormType}
      // showButtons={true}
      // PlutonicuserID={
      //   PlutonicuserID || localStorage.getItem("PlutonicuserID")
      // }
      />
      <div
        className="fall-page-background relative flex flex-col items-center min-h-screen pt-20 sm:pt-24 pb-12 sm:pb-16 px-4 sm:px-6 lg:px-12 mx-auto"
      >
      <FallScene />

    
    <div className="relative z-10 w-full" style={{ transform: "translateZ(0)" }}>
        <div className="fall-scene-heading-panel mb-5 sm:mb-8 mt-6 sm:mt-8">
          <h1 className="flex items-center text-2xl sm:text-3xl font-bold">
            Your Virtual Spaces
              <RefreshMeetingsButton onRefresh={refreshMeetings} refreshing={refreshing} />
          </h1>
          <h2 className="text-base sm:text-xl font-bold mt-2">
            Select Your Preferred Session Space
          </h2>
        </div>
          {refreshError && <p role="alert" className="text-red-600">{refreshError}</p>}

        <div className="grid gap-5 sm:gap-8 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 w-full">
          {rooms.map((room) => (
            <TherapyRoomCard
              key={room.id}
              room={room}
              isSelected={selectedSpace === room.id}
              onSelect={
                room.mobileComingSoon
                  ? undefined
                  : () => handleSpaceSelection(room.id)
              }
              onEnterClick={(meetingID) => handleEnterClick(room.id, meetingID)}
              sessions={enabledRoom[room.id] || []}
              preloadState={preloadStates[room.id]}
            />
          ))}
        </div>
        </div>
      </div>
      <WarningBanner />
      <Footer />
    </div>
  );
}

export default ClientTherapyRooms;
